import { render, staticRenderFns } from "./ClinicNurseDashboardMiddle.vue?vue&type=template&id=18757540&"
import script from "./ClinicNurseDashboardMiddle.vue?vue&type=script&lang=js&"
export * from "./ClinicNurseDashboardMiddle.vue?vue&type=script&lang=js&"
import style0 from "./ClinicNurseDashboardMiddle.vue?vue&type=style&index=0&id=18757540&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports